import { BehaviorSubject } from "@/lib/behavior-subject";
import type { DeepGroupByRowState } from "./table.types";

export const fixedColumns$ = new BehaviorSubject<string[]>([]);
export const deepGroupByRow$ = new BehaviorSubject<DeepGroupByRowState | null>(null);
